import Button from '../../common/Button';

const ModuleCardActions = ({ durationLabel, isPaid, onBuyClick }) => {
    return (
        <div className='df fdc aife jcfe' style={{ flexShrink: 0, gap: '6px', marginLeft: '0.5rem' }}>
            {durationLabel && (
                <div className='df aic' style={{ gap: '4px' }}>
                    <img src={require('../../../../images/dashboard/stopwatch.svg')} style={{ width: '14px', height: '14px' }} alt="" />
                    <span className='fs12px fw500 c15'>{durationLabel}</span>
                </div>
            )}
            {isPaid && (
                <Button
                    text='Buy Now'
                    onClick={() => onBuyClick && onBuyClick()}
                    btnType="warning"
                    style={{ padding: '0.25rem 1rem', marginBottom: '4px' }}
                />
            )}
        </div>
    );
};

export default ModuleCardActions;
